// Components==============
import indexAssessment from 'actions/assessment/index';
import indexTheme from 'actions/theme/index';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import FeedbackCard from 'components/UI/ProjectCard/components/Card/FeedbackCard';
// import Title from 'components/UI/Title/Title';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
// import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './AssessmentOverview.module.scss';
import { getDate } from 'utilities/getDate';
// =========================

export default function AssessmentOverview() {
  const dispatch = useDispatch();
  // const translate = useTranslate();

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexAssessment());
  }, []);

  const loading = useRedux(
    (state) => state.theme?.loading || state.assessment?.loading
  );

  const userId = useRedux((state) => state.authentication?.user?.id);

  const isTeacher = usePermission(['Docent']);

  const isExtern = usePermission(['Extern']);

  const assessments = useRedux((state) =>
    state.assessment.entities.allIds.map(
      (id) => state.assessment.entities.byId[id]
    )
  );
  const completedAssessments = assessments
    .filter(
      (assessment) =>
        assessment.first_assessor_done === 1 &&
        assessment.second_assessor_done === 1
    )
    .sort((a, b) => getDate(b.updated_at) - getDate(a.updated_at));

  const beingAssessed = assessments
    .filter(
      (assessment) =>
        assessment.first_assessor_done === 0 ||
        assessment.second_assessor_done === 0
    )
    .filter((assessment) => {
      // dynamic filter
      if (
        // check if we are the first assessor, and we are done. In that case, hide the assessment tile
        assessment.first_assessor_id === userId &&
        assessment.first_assessor_done === 1
      ) {
        return false;
      }
      if (
        // check if we are the second assessor, and the first assessor is not done yet. In that case, hide the assessment tile
        assessment.second_assessor_id === userId &&
        assessment.first_assessor_done === 0
      ) {
        return false;
      }
      return true;
    })
    .sort((a, b) => getDate(b.updated_at) - getDate(a.updated_at));

  const getLockedForAssessment = (assessment: AssessmentEntity) => {
    if (
      assessment.first_assessor_done === 0 &&
      assessment.first_assessor_id === userId
    ) {
      return false;
    }
    if (
      assessment.first_assessor_done === 1 &&
      assessment.second_assessor_id === userId
    ) {
      return false;
    }
    if (
      assessment.first_assessor_done === 1 &&
      assessment.second_assessor_done === 1
    ) {
      return false;
    }
    return true;
  };

  return (
    <Layout>
      <NoContent
        loading={!!loading}
        hasContent={!!completedAssessments.length || !!beingAssessed.length}
        page={
          isExtern
            ? 'assessments-extern'
            : isTeacher
            ? 'assessments-teacher'
            : 'assessments'
        }
      >
        <Container>
          {!!beingAssessed.length && (
            <>
              {/* <Title text="general.terms.review" loading={loading} /> */}
              <h1 styleName="secondary-title">
                {`${
                  assessments?.some(
                    (assessment) =>
                      assessment.first_assessor_id === userId ||
                      assessment.second_assessor_id === userId
                  )
                    ? 'Klaar voor beoordelen'
                    : 'In afwachting van beoordeling'
                }`}
              </h1>
              <div styleName="wrapper">
                {beingAssessed.map((assessment, i) => (
                  <FeedbackCard
                    key={i}
                    student={assessment.student}
                    theme={assessment?.project?.theme}
                    assessmentId={assessment.id}
                    assessment={assessment}
                    isLocked={getLockedForAssessment(assessment)}
                  />
                ))}
              </div>
            </>
          )}
          {!!completedAssessments.length && (
            <>
              {/* <Title text="general.terms.review" loading={loading} /> */}
              <h1 styleName="secondary-title">Beoordeeld</h1>
              <div styleName="wrapper">
                {completedAssessments.map((assessment, i) => (
                  <FeedbackCard
                    key={i}
                    student={assessment.student}
                    theme={assessment?.project?.theme}
                    assessmentId={assessment.id}
                    assessment={assessment}
                    isAssessed
                    isLocked={getLockedForAssessment(assessment)}
                  />
                ))}
              </div>
            </>
          )}
        </Container>
      </NoContent>
    </Layout>
  );
}
